export default "__VITE_ASSET__CkLwmCCQ__"